<template>
  <div class="blkDocCreation">
    <div class="form-info">
      <el-form
        ref="form"
        :model="form"
        :rules="validationRules"
        :inline-message="false"
        label-position="right"
        label-width="205px"
      >
        <div class="group__info has-border__bottom padding-bottom-10">
          <div class="title font-size__medium">Thông tin vào sổ</div>
          <div class="content">
            <div class="form-input">
              <el-form-item
                class="margin-bottom-5"
                prop="bookId"
                label="Sổ đến"
              >
                <!-- <span class="label-input field-needed">Sổ đến</span> -->
                <el-select
                  clearable
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                  v-model="form.bookId"
                  ref="selectBook"
                  filterable
                  placeholder="-"
                  @visible-change="generateNextBookNumber()"
                >
                  <el-option
                    v-for="item in books"
                    :key="item.id"
                    :label="item.bookName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!--              <div class="flex-row flex__left">-->
              <el-row :gutter="12">
                <el-col :span="14">
                  <el-form-item prop="bookNumber" label="Số đến: ">
                    <!-- <span class="label-input">Số đến: </span> -->
                    <el-input-number
                      class="style-fullWidth input-font__bold"
                      v-model="form.bookNumber"
                      size="mini"
                      placeholder="-"
                      :controls="true"
                      :min="0"
                      :step="1"
                      :precision="0"
                      :max="1000000"
                    >
                    </el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item prop="incomingDate" label="Ngày đến">
                    <!-- <span class="label-input field-needed width__120"
                      >Ngày đến</span
                    > -->
                    <el-date-picker
                      class="
                        style-fullWidth
                        input-bg__transparent
                        input-font__bold
                        input-border__bottom input-border__radius__0
                      "
                      size="mini"
                      v-model="incomingDate"
                      type="date"
                      :disabled="true"
                      placeholder="dd/mm/yyyy"
                      :prefix-icon="' '"
                      format="dd/MM/yyyy"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--              </div>-->
            </div>
          </div>
        </div>
        <div class="group__info margin-top-10 padding-bottom-10">
          <div class="title font-size__medium">Thông tin văn bản</div>
          <div class="content">
            <div class="form-input">
              <div class="file-uploaded input-none__border" v-if="vbAttachment">
                <div class="file-uploaded">
                  <div class="file clickable flex-row flex__between">
                    <a
                      v-openInNewTab
                      :href="
                        getToken(vbAttachment.id)
                          | buildAttachmentURL({
                            type: DOWNLOAD_OPTION.TYPE.ORIGINAL,
                          })
                      "
                      class="flex-row flex__left"
                    >
                      <fileTypeImage
                        :fileExtention="vbAttachment.fileExtention"
                        :customClass="'icon-small margin-right-10'"
                      />
                      <span class="fileName font-weight_normal">{{
                        vbAttachment.fileName
                      }}</span>
                    </a>
                    <!-- v-if="
                        form.status !== INCOMING_DOC_STATUS.TAO_MOI &&
                        form.status !== INCOMING_DOC_STATUS.TU_CHOI
                      " -->
                    <i
                      class="
                        el-icon-circle-close
                        margin-left-10
                        font-size__large
                        color__red
                      "
                      @click="removeUploadAttachment"
                    ></i>
                  </div>
                </div>
              </div>

              <el-form-item prop="attachment" class="input-no__label" v-else>
                <el-upload
                  class="upload-demo style-fullWidth input-border__bottom"
                  drag
                  :action="uploadAttachmentURL"
                  size=""
                  :on-success="
                    (response) =>
                      onUploadSuccess(response).then((response) =>
                        uploadAttachmentSuccess(response)
                      )
                  "
                  :data="uploadAttachmentAdditionalData"
                  :file-list="form.attachmentFiles"
                  :show-file-list="false"
                  :headers="uploadAttachmentHeaders"
                  :accept="DOCUMENT_FILE.ACCEPT_TYPES"
                  :before-upload="(file) => validateUploadFile(file)"
                  :on-error="onUploadError"
                  v-loading="isUploading"
                >
                  <!-- :disabled="
                    form.status === INCOMING_DOC_STATUS.TAO_MOI ||
                    form.status === INCOMING_DOC_STATUS.TU_CHOI
                  " -->
                  <div class="el-upload__text">
                    <p class="margin-0 padding-0">Tải tệp đính kèm:</p>
                    <i class="fas fa-cloud-upload color__silver"></i>
                  </div>
                </el-upload>
              </el-form-item>

              <el-form-item prop="docCode" label="Số ký hiệu: ">
                <!-- <span class="label-input">Số ký hiệu: </span> -->

                <el-input
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                  v-model="form.docCode"
                  size=""
                  placeholder="-"
                  maxlength="100"
                  @change="docCodeChanged"
                >
                </el-input>
              </el-form-item>

              <el-form-item prop="docDate" label="Ngày văn bản: ">
                <!-- <span class="label-input field-needed">Ngày văn bản: </span> -->
                <el-date-picker
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                  size=""
                  v-model="docDate"
                  type="date"
                  placeholder="dd/mm/yyyy"
                  :prefix-icon="' '"
                  format="dd/MM/yyyy"
                  :picker-options="datePickerOptions"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item prop="docTypeId" label="Loại văn bản: ">
                <!-- <span class="label-input">Loại văn bản: </span> -->
                <el-select
                  clearable
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                  v-model="form.docTypeId"
                  size=""
                  filterable
                  placeholder="-"
                >
                  <el-option
                    v-for="item in docTypes"
                    :key="item.id"
                    :label="item.categoryName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                prop="publisherId"
                v-if="!incomingDoc || incomingDoc.publisher"
              >
                <template v-slot:label>
                  <span>Đơn vị phát hành (bên trong)</span>
                  <el-tooltip
                    content="Cây danh mục đơn vị"
                    placement="top"
                    effect="dark"
                  >
                    <i
                      class="fas fa-cog advance-search color__cyan clickable"
                      @click="isOpenSelectDepartmentDialog = true"
                    ></i>
                  </el-tooltip>
                </template>
                <el-select
                  filterable
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                  v-model="form.publisherId"
                  placeholder="Nhập tên đơn vị để tìm kiếm"
                  clearable
                  @change="publisherIdChange"
                >
                  <el-option
                    v-for="item in departments"
                    :label="customDeptName(item)"
                    :key="item.id"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                v-if="!incomingDoc || incomingDoc.outsidePublisherName"
                label="Đơn vị phát hành (bên ngoài): "
              >
                <!-- <span class="label-input">Đơn vị phát hành (bên ngoài): </span> -->
                <el-select
                  :disabled="!!form.publisherId || !!isBanHanhTrucLienThong"
                  :class="[
                    'style-fullWidth input-font__bold input-border__bottom input-border__radius__0',
                    form.publisherId ? 'input-bg__transparent' : '',
                  ]"
                  v-model="form.outsidePublisherName"
                  filterable
                  allow-create
                  default-first-option
                  remote
                  reserve-keyword
                  :remote-method="remoteMethod"
                  :loading="isLoading"
                  class="
                    style-fullWidth
                    input-border__bottom input-border__radius__0
                  "
                >
                  <el-option
                    v-for="(item, index) in listInsideReceiver"
                    :key="index"
                    :label="item.deptName"
                    :value="item.deptName"
                  >
                  </el-option>
                </el-select>
                <!--                <el-input-->
                <!--                    :class="[-->
                <!--                    'style-fullWidth input-font__bold input-border__bottom input-border__radius__0',-->
                <!--                    form.publisherId ? 'input-bg__transparent' : ''-->
                <!--                  ]"-->
                <!--                    v-model="form.outsidePublisherName"-->
                <!--                    size=""-->
                <!--                    placeholder="-"-->
                <!--                    maxlength="500"-->
                <!--                    @change="clearValidate()"-->
                <!--                    :disabled="form.publisherId ? true : false"-->
                <!--                >-->
                <!--                </el-input>-->
              </el-form-item>

              <el-form-item
                v-if="incomingDoc && incomingDoc.forwardDeptName"
                label="Nơi gửi: "
              >
                <!-- <span class="label-input">Nơi gửi: </span> -->
                <el-input
                  :class="[
                    'style-fullWidth input-font__bold input-border__bottom input-border__radius__0',
                    form.publisherId ? 'input-bg__transparent' : '',
                  ]"
                  v-model="incomingDoc.forwardDeptName"
                  size="mini"
                  placeholder="-"
                  maxlength="500"
                  :disabled="true"
                >
                </el-input>
              </el-form-item>

              <el-form-item prop="quote" label="Trích yếu">
                <!-- <span class="label-input field-needed">Trích yếu</span> -->
                <el-input
                  type="textarea"
                  rows="1"
                  maxlength="2000"
                  v-model="form.quote"
                  placeholder="-"
                  autosize
                  resize="none"
                  class="
                    input-font__bold
                    style-fullWidth
                    input-border__bottom input-border__radius__0
                  "
                ></el-input>
              </el-form-item>

              <el-form-item prop="priorityId" label="Độ khẩn: ">
                <!-- <span class="label-input">Độ khẩn: </span> -->
                <multiselect
                  :class="[
                    form.priorityId ? '' : '',
                    'style-fullWidth input-font__bold',
                    'input-border__radius__0',
                  ]"
                  :options="priorities"
                  label="categoryName"
                  track-by="id"
                  :preselect-first="true"
                  v-model="priority"
                  placeholder="-"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :searchable="true"
                  open-direction="top"
                >
                  <template slot="noResult"
                    >Không tìm thấy dữ liệu phù hợp.
                  </template>
                  <template slot="noOptions">Danh sách trống </template>
                  <template slot="singleLabel" slot-scope="{ option }">
                    <el-tag
                      size="medium"
                      :class="[
                        'priority',
                        option.categoryName == 'Hỏa tốc' ? 'lv1' : '',
                        option.categoryName == 'Bình thường' ? 'lv3' : '',
                        option.categoryName == 'Khẩn' ? 'lv2' : '',
                      ]"
                    >
                      {{ option.categoryName }}
                    </el-tag>
                  </template>
                </multiselect>
              </el-form-item>

              <el-form-item prop="deadlineDate" label="Hạn xử lý: ">
                <!-- <span class="label-input">Hạn xử lý: </span> -->
                <el-date-picker
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                  v-model="deadlineDate"
                  type="datetime"
                  :prefix-icon="' '"
                  placeholder="dd/mm/yyyy"
                  default-time="17:30:00"
                  format="dd/MM/yyyy HH:mm"
                ></el-date-picker>
              </el-form-item>

              <el-row :gutter="12">
                <el-col :span="15">
                  <el-form-item prop="numberOfPage" label="Số trang: ">
                    <!-- <span class="label-input">Số trang: </span> -->
                    <el-input-number
                      class="style-fullWidth input-font__bold"
                      v-model="form.numberOfPage"
                      placeholder="-"
                      size="mini"
                      :controls="true"
                      :min="0"
                      :step="1"
                      :precision="0"
                      :max="1000"
                    >
                    </el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item
                    label="Số bản: "
                    prop="numberOfCopy"
                    label-width="60px"
                  >
                    <!-- <span class="label-input width__auto">Số bản: </span> -->
                    <el-input-number
                      :controls="true"
                      class="style-fullWidth input-font__bold"
                      v-model="form.numberOfCopy"
                      placeholder="-"
                      size="mini"
                      :min="0"
                      :step="1"
                      :precision="0"
                      :max="1000"
                    >
                    </el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item prop="description" label="Ghi chú: ">
                <el-input
                  type="textarea"
                  rows="3"
                  v-model="form.description"
                  maxlength="1000"
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                ></el-input>
              </el-form-item>
              <!--văn bản quy phạm pháp luật-->
              <el-form-item
                label="Văn bản quy phạm pháp luật"
                v-if="isBanHanhTrucLienThong"
              >
                <!-- <span class="label-input">Văn bản quy phạm pháp luật</span> -->
                <el-checkbox
                  :border="false"
                  v-model="form.isLawDocument"
                  class="style-fullWidth has-border__bottom"
                ></el-checkbox>
              </el-form-item>
              <!--loại chỉ đạo-->
              <el-form-item
                class="margin-top-10"
                v-if="isBanHanhTrucLienThong"
                prop="steeringTypeId"
                label="Loại chỉ đạo"
              >
                <!-- <span :class="['label-input', 'field-needed']"
                  >Loại chỉ đạo</span
                > -->
                <el-select
                  clearable
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                  v-model="form.steeringTypeId"
                  filterable
                  placeholder="-"
                >
                  <el-option
                    v-for="item in steeringTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>

        <div
          v-if="docRelations && docRelations.length > 0"
          class="group__info margin-top-10 margin-bottom-10 padding-bottom-10"
        >
          <div class="title font-size__medium">Văn bản liên quan</div>
          <div class="ctn">
            <template>
              <el-table
                class="table detailRelatedDocs"
                :data="docRelations"
                style="max-width: 100%; width: 100%"
                size="mini"
              >
                <el-table-column label="Trích yếu" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="docName flex-row flex__left margin-right-10">
                      <file-type-image
                        :custom-class="''"
                        :file-extention="scope.row.fileExtention"
                      >
                      </file-type-image>

                      <a
                        class="txt style-fullWidth margin-left-10 color__black"
                        :href="
                          getTokenDocRelation(scope.row.id)
                            | buildAttachmentURL({
                              type:
                                scope.row.objectTypeRelateTo ===
                                DOC_RELATION_OBJECT_TYPE.ATTACHMENT
                                  ? DOWNLOAD_OPTION.TYPE.ORIGINAL
                                  : DOWNLOAD_OPTION.TYPE.PDF,
                            })
                        "
                        v-openInNewTab
                      >
                        {{ scope.row.quote || "-" }}
                      </a>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Loại văn bản"
                  width="100"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ getRelationTypeLabel(scope.row.relationType) || "-" }}
                  </template>
                </el-table-column>

                <el-table-column
                  label="Số ký hiệu"
                  width="120"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ scope.row.docCode || "-" }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Ngày văn bản"
                  width="135"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.docDate
                        | dateFormatter({ dateFormat: "DD/MM/YYYY" })
                    }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
        </div>
        <doc-relations-form
          :title="'Văn bản liên quan'"
          :docId="id"
          v-if="!id"
          ref="docRelationsForm"
        ></doc-relations-form>
        <div class="group__info margin-top-10 padding-bottom-10">
          <div class="title font-size__medium">Quy trình xử lý</div>
          <div class="content">
            <div class="form-input">
              <el-form-item prop="flowId">
                <span slot="label" class="label-input field-needed"
                  >Chọn quy trình</span
                >
                <el-select
                  clearable
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                  v-model="form.flowId"
                  size=""
                  filterable
                  placeholder="-"
                  @change="flowIdChange"
                >
                  <el-option
                    v-for="item in flows"
                    :key="item.id"
                    :label="item.flowName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <div v-if="selectedNodes && selectedNodes.length">
                <el-form-item>
                  <el-table
                    :data="selectedNodes"
                    size="mini"
                    fit
                    style="width: 100%; height: 100%"
                    stripe
                  >
                    <el-table-column type="index" width="40"></el-table-column>
                    <el-table-column label="Cá nhân/ đơn vị">
                      <template slot-scope="scope">
                        <div
                          class="flex-row flex__left"
                          v-if="scope.row.stepType === STEP.STEP_TYPE.CANHAN"
                        >
                          <div class="avt">
                            <div class="avatar_fake flex-row flex__center">
                              <span>{{
                                scope.row.userDeptRole.fullName
                                  | buildShortNameFilter
                              }}</span>
                            </div>
                          </div>
                          <div class="info margin-left-10">
                            <p class="people__name">
                              {{ scope.row.userDeptRole.fullName }}
                            </p>
                            <p class="people__position">
                              {{ scope.row.userDeptRole.positionName }} -
                              {{ scope.row.userDeptRole.deptName }}
                            </p>
                          </div>
                        </div>
                        <div class="flex-row flex__left" v-else>
                          <div class="avt"></div>
                          <div class="info margin-left-10">
                            <p class="people__name">
                              {{ scope.row.department.deptName }}
                            </p>
                            <p class="people__position">
                              {{ scope.row.department.identityCode }}
                            </p>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Vai trò"
                      width="120"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <p>{{ buildProcessType(scope.row.processType) }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column width="50">
                      <template slot-scope="scope">
                        <div
                          class="clickable icon-zoom btn-unselect"
                          @click="removeSelectedNode(scope.row)"
                        >
                          <i class="el-icon-circle-close font-size__large"></i>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
              <div
                class="flex-row flex__right"
                v-show="selectedNodes && selectedNodes.length"
              >
                <span class="label-input">
                  <el-button
                    size="mini"
                    class="dialogBtnPrimary"
                    @click="isOpenTransferDialog = true"
                    style="margin-bottom: 10px"
                  >
                    <i class="font-size__small fas fa-pencil-alt"></i>
                    &nbsp;Sửa
                  </el-button>
                </span>
              </div>

              <el-form-item prop="flowNote" label="Ý kiến/đề xuất: ">
                <!-- <span class="label-input">Ý kiến/đề xuất: </span> -->
                <el-input
                  type="textarea"
                  rows="3"
                  v-model="form.flowNote"
                  class="
                    style-fullWidth
                    input-font__bold
                    input-border__bottom input-border__radius__0
                  "
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <div class="el-dialog__footer">
        <div class="flex-row flex__left form-button__action">
          <el-button
            class="dialogBtnPrimary"
            @click="forwardToNextHandler()"
            :disabled="isProcessing"
          >
            <el-tooltip content="Chuyển Lãnh đạo" placement="top">
              <span class="flex-row flex__center">
                <i
                  :class="[
                    !isProcessing
                      ? 'font-size__small far fa-arrow-alt-circle-right'
                      : 'el-icon-loading',
                  ]"
                ></i>
                &nbsp;Chuyển xử lý
              </span>
            </el-tooltip>
          </el-button>
          <el-button
            v-if="isEnableDelete || !id"
            class="dialogBtnPrimary"
            @click="isOpenSaveDocInDialog = true"
            :disabled="isProcessing"
          >
            <el-tooltip content="Lưu trữ văn bản" placement="top">
              <span class="flex-row flex__center">
                <i
                  :class="[
                    !isProcessing
                      ? 'font-size__small far fa-arrow-alt-circle-right'
                      : 'el-icon-loading',
                  ]"
                ></i>
                &nbsp;Lưu trữ
              </span>
            </el-tooltip>
          </el-button>
          <el-button
            class="dialogBtnPrimary"
            @click="saveDoc()"
            :disabled="isProcessing"
          >
            <el-tooltip content="Thêm mới văn bản" placement="top">
              <span class="flex-row flex__center">
                <i
                  :class="[
                    !isProcessing
                      ? 'font-size__small far fa-save'
                      : 'el-icon-loading',
                  ]"
                ></i>
                &nbsp;{{ id ? "Cập nhật" : "Tạo mới" }}
              </span>
            </el-tooltip>
          </el-button>
          <el-button
            class="detailBtn btn__delete btn-none__border color__white bg__red"
            v-show="isEnableTuChoi"
            @click="tuChoiTiepNhan()"
          >
            <i class="fas fa-ban font-size__small"></i>&nbsp; Từ chối
          </el-button>
          <el-button
            class="detailBtn btn__delete btn-none__border color__white bg__red"
            @click="delete_()"
            v-if="isEnableDelete"
          >
            <i class="fas fa-trash font-size__small"></i>&nbsp; Xóa
          </el-button>
          <el-button
            type="info"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <el-tooltip content="Hủy" placement="top">
              <span class="flex-row flex__center">
                <i class="font-size__small el-icon-circle-close-outline"></i>
                &nbsp;Hủy
              </span>
            </el-tooltip>
          </el-button>
        </div>
      </div>

      <select-department-dialog
        :isOpen="isOpenSelectDepartmentDialog"
        :publisherId="deptId"
        :receiveDepartmentIds="form.publisherId"
        v-if="isEnableSelectDepartmentDialog"
        @closed="isEnableSelectDepartmentDialog = false"
        @closeDialog="isOpenSelectDepartmentDialog = false"
        @change="publisherDepartmentChange"
      >
      </select-department-dialog>

      <accept-save-doc-in
        :isOpen="isOpenSaveDocInDialog"
        v-if="isEnableSaveDocInDialog"
        @closed="isEnableSaveDocInDialog = false"
        @closeDialog="isOpenSaveDocInDialog = false"
        @saveDocIn="saveInBook"
      >
      </accept-save-doc-in>

      <tu-choi-van-thu-dialog
        :isOpen="isOpenTuChoiDialog"
        :vbIncomingDocId="incomingDoc.id"
        v-if="isEnableTuChoiDialog"
        @closeDialog="isOpenTuChoiDialog = false"
        @dialogClosed="isEnableTuChoiDialog = false"
        @success="tuChoiTiepNhanSuccess"
      >
      </tu-choi-van-thu-dialog>

      <cxl-vbden-vanthu-dialog
        :isOpen="isOpenTransferDialog"
        :flowId="flowId"
        :quote="form.quote"
        :note="form.flowNote"
        :selectedHandlers="selectedNodes"
        v-if="isEnableTransferDialog"
        @closed="isEnableTransferDialog = false"
        @closeDialog="isOpenTransferDialog = false"
        @submit="selectHandler"
      >
      </cxl-vbden-vanthu-dialog>
    </div>
  </div>
</template>
<script>
import categoryViewService from "../../services/categoryViewService";
import docRelationService from "../../services/docRelationService";
import constants from "../../constants";
import h from "../../services/h";
import flowService from "../../services/flowService";
import departmentService from "../../services/departmentService";
import nextStepInfoViewService from "../../services/nextStepInfoViewService";
import dateUtils from "../../dateUtils";
import attachmentService from "../../services/attachmentService";
import bookService from "../../services/bookService";
import docInService from "../../services/docInService";
import docInBookService from "../../services/docInBookService";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import vbIncomingProcessService from "../../services/vbIncomingProcessService";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import uploadFileMixin from "./uploadFileMixin";
import tuChoiVanThuDialog from "./components/tuChoiVanThuDialog";
import dateFormatter from "../../filters/dateFormatter";
import buildShortNameFilter from "../../filters/buildShortNameFilter";
import otherDepartmentService from "../../services/otherDepartmentService";
import Transfer from "./components/TransferNewVanThu";
import vbIncomingDocService from "../../services/vbIncomingDocService";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import CxlVbdenVanthuDialog from "./components/clx-vbden-vanthu-dialog";
import incomingDocService from "../../services/incomingDocService";
import errorMessageFilter from "../../filters/errorMessageFilter";
import DocRelationsForm from "./doc-relations-form";
import AcceptSaveDocIn from "./acceptSaveDocIn.vue";

export default {
  name: "doc-in-create",
  mixins: [vbAttachmentTokenMixin, uploadFileMixin, handleRequestErrorMixin],
  filters: { buildAttachmentURL, dateFormatter, buildShortNameFilter },
  components: {
    CxlVbdenVanthuDialog,
    fileTypeImage: () => import("../job/FileTypeImage"),
    selectDepartmentDialog: () => import("./components/selectDepartmentDialog"),
    Transfer,
    tuChoiVanThuDialog,
    DocRelationsForm,
    AcceptSaveDocIn,
  },
  props: ["id"],

  data() {
    let publisherValidation = (rule, value, callback) => {
      if (!this.form.publisherId && !this.form.outsidePublisherName) {
        return callback(new Error("Đơn vị phát hành bắt buộc nhập"));
      }
      return callback();
    };
    let handlerValidation = (rule, value, callback) => {
      if (!this.form.handlerId && !this.form.handlerDeptId) {
        return callback(new Error("Trường bắt buộc nhập"));
      }
      return callback();
    };

    return {
      insideReceiver: null,
      listInsideReceiver: [],
      isLoading: false,

      selectedNodes: [],
      defaultFlow: null,
      isOpenTransferDialog: false,
      isEnableTransferDialog: false,

      isOpenSaveDocInDialog: false,
      isEnableSaveDocInDialog: false,

      docRelationTypes: [],
      DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
      docRelations: [],

      INCOMING_DOC_STATUS: constants.INCOMING_DOC_STATUS,
      vbAttachmentsState: {},
      DOCUMENT_FILE: constants.DOCUMENT_FILE,
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      STEP: constants.STEP,

      incomingDoc: null,
      priorities: [],
      docTypes: [],
      flows: [],
      nextStep: null,
      departments: [],
      docDate: null,
      incomingDate: null,
      deadlineDate: null,
      handlers: [],
      nextStepsCaNhan: [],
      nextStepsDonVi: [],
      deptForNextStep: [],
      vbAttachment: null,
      books: null,
      handler: [],
      handlerDept: null,
      priority: null,
      docInBook: null,

      form: {
        docCode: null,
        // incomingDate: null,
        bookNumber: null,
        subBookNumber: null,
        docTypeName: null,
        attachmentFiles: [],
        quote: null,
        attachmentId: null,
        publisherId: null,
        outsidePublisherName: null,
        docTypeId: null,
        docDate: null,
        deadlineDate: null,
        priorityId: null,
        numberOfCopy: null,
        numberOfPage: null,
        flowId: null,
        handlerId: null,
        handlerDeptId: null,
        handlerRoleId: null,
        handlerPositionId: null,
        flowNote: null,
        bookId: null,
        isLawDocument: null,
        steeringTypeId: null,
      },

      validationRules: {
        docDate: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change",
          },
        ],
        bookId: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change",
          },
        ],
        bookNumber: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change",
          },
        ],
        // incomingDate: [{required: true, message: 'Trường dữ liệu bắt buộc', trigger: 'change'},],
        publisherId: [{ validator: publisherValidation, trigger: "change" }],
        outsidePublisherName: [
          { validator: publisherValidation, trigger: "change" },
        ],

        quote: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "change",
          },
          {
            max: 2000,
            message: "Không vượt quá 2000 kí tự",
            trigger: "change",
          },
        ],
        //
        // flowId: [
        //   {required: true, message: "Trường bắt buộc chọn", trigger: "change"}
        // ],

        handlerId: [{ validator: handlerValidation, trigger: "change" }],
        handlerDeptId: [{ validator: handlerValidation, trigger: "change" }],
      },

      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,

      isOpenTuChoiDialog: false,
      isEnableTuChoiDialog: false,

      processHandlerForms: [],
      processHandlerDeptForms: [],
      isProcessing: false,
      steeringTypes: null,
    };
  },

  computed: {
    isBanHanhTrucLienThong() {
      return this.incomingDoc && this.incomingDoc.tltvbAgencyId;
    },

    docStatus() {
      if (this.incomingDoc && this.incomingDoc.vbOutgoingDocId)
        return this.incomingDoc.status;
      else return "";
    },

    flowId() {
      return this.form.flowId;
    },
    bookId() {
      return this.form.bookId;
    },
    uploadAttachmentAdditionalData() {
      return {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DEN,
        note: "",
      };
    },
    isVanThu() {
      return (
        this.userDeptRole &&
        this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
      );
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    parentRoute() {
      return this.$route.path.split("/")[3];
    },
    isEnableTuChoi() {
      return (
        this.incomingDoc &&
        (this.incomingDoc.forwardIncomingDocId ||
          this.incomingDoc.vbOutgoingDocId ||
          (this.incomingDoc.documentId &&
            !this.incomingDoc.forwardIncomingDocId))
      );
    },
    isEnableDelete() {
      //văn thư được phép xóa văn bản ký ngoài
      return (
        this.isVanThu &&
        this.incomingDoc &&
        this.deptId === this.incomingDoc.toDeptId &&
        !this.incomingDoc.vbOutgoingDocId &&
        !this.incomingDoc.forwardIncomingDocId &&
        !(this.incomingDoc.documentId && !this.incomingDoc.forwardIncomingDocId)
      );
    },
    datePickerOptions() {
      return {
        disabledDate: (time) => {
          return time.getTime() > new Date();
        },
      };
    },
  },

  watch: {
    isOpenSaveDocInDialog(newValue) {
      newValue && (this.isEnableSaveDocInDialog = newValue);
    },

    isOpenTransferDialog(newValue) {
      newValue && (this.isEnableTransferDialog = newValue);
    },

    id(newValue) {
      if (newValue) {
        this.loadDocDetail()
          .then(() => this.loadDocInBook())
          .then(() => this.loadBooks())
          .then(() => this.prepareFormForEditMode());
      } else {
        this.loadBooks();
      }
    },

    handler(newValue) {
      if (!newValue && !newValue.length) {
        this.$refs.form && this.$refs.form.clearValidate("handlerId");
      }
      // this.form.handlerId = handlers[0] ? handlers[0].userView.userId : null;
      // let handlers = newValue;
      let handlers = [];
      newValue &&
        newValue.forEach((id) => {
          handlers.push(
            h.find(
              this.handlers,
              (item, index) => newValue && item.id.indexOf(id) !== -1
            )
          );
        });
      this.form.handlerId = handlers[0] ? handlers[0].userView.userId : null;

      // this.$refs.form && this.$refs.form.validateField("handlerId");

      this.processHandlerForms = [];
      h.each(handlers, (handler) => {
        this.processHandlerForms.push({
          userId: handler.userView.userId,
          deptId: handler.userView.deptId,
          roleId: handler.userView.roleId,
          positionId: handler.userView.positionId,
          processType: constants.PROCESS_TYPE.CHUTRI,
          stepId: handler.stepId,
          delegateInfoId: handler.userView.delegateInfoId,
        });
      });
    },

    handlerDept(newValue) {
      if (!newValue) return;
      let handlerDepts = newValue;
      this.form.handlerDeptId = newValue[0] ? newValue[0].id : null;

      this.processHandlerDeptForms = [];
      h.each(handlerDepts, (handlerDept) => {
        this.processHandlerDeptForms.push({
          deptId: handlerDept.id,
          stepId: handlerDept.stepId,
        });
      });
    },

    docDate(value) {
      this.form.docDate = value ? value.getTime() : null;
    },

    deadlineDate(value) {
      this.form.deadlineDate = value ? value.getTime() : null;
    },
    priority(newValue) {
      this.form.priorityId = newValue ? newValue.id : null;
    },
    isOpenSelectDepartmentDialog(newValue) {
      newValue && (this.isEnableSelectDepartmentDialog = newValue);
    },
    isOpenTuChoiDialog(newValue) {
      newValue && (this.isEnableTuChoiDialog = newValue);
    },
  },

  created() {
    this.incomingDate = new Date();
    this.loadCategories();
    this.loadFlows();
    this.loadDepartments();
    this.initSteeringTypes();
    if (this.id) {
      this.loadDocDetail()
        .then(() => this.loadDocInBook())
        .then(() => this.loadBooks())
        .then(() => this.prepareFormForEditMode());
    } else {
      this.loadBooks();
    }
    this.deadlineDate = new Date(
      new Date().getTime() + 7 * 24 * 60 * 60 * 1000
    );
    this.form.numberOfCopy = 1;
  },

  methods: {
    initSteeringTypes() {
      this.steeringTypes = [
        {
          id: constants.STEERING_TYPE.KHONGPHAICHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.khongphaichidao",
          }),
        },
        {
          id: constants.STEERING_TYPE.CHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.chidao",
          }),
        },
        {
          id: constants.STEERING_TYPE.BAOCAOCHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.baocaochidao",
          }),
        },
      ];
    },

    docCodeChanged() {
      this.form.docCode = (this.form.docCode || "").toUpperCase();
    },

    remoteMethod(query) {
      if (query !== "") {
        this.findOtherDept(query);
      } else {
        this.options = [];
      }
    },

    findOtherDept(query) {
      this.isLoading = true;
      otherDepartmentService
        .search(query, this.deptId, { sort: "count,desc", page: 0, size: 20 })
        .then((res) => {
          this.listInsideReceiver = res.data;
          this.isLoading = false;
        });
    },

    removeSelectedNode(row) {
      this.selectedNodes.splice(this.selectedNodes.indexOf(row), 1);
    },

    buildProcessType(processType) {
      switch (processType) {
        case constants.PROCESS_TYPE.CHUTRI:
          return "Chủ trì";
        case constants.PROCESS_TYPE.PHOIHOP:
          return "Phối hợp";
        case constants.PROCESS_TYPE.NHANDEBIET:
          return "Nhận để biết";
        default:
          return "Chủ trì";
      }
    },
    delete_() {
      this.$confirm(
        `Bạn có muốn xóa văn bản "${this.incomingDoc.quote}" ?`,
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning",
        }
      ).then(() => {
        incomingDocService
          .deleteForVanThu(this.id)
          .then(() => {
            this.$message({
              message: "Xóa thành công",
              type: "success",
              duration: 2000,
            });
            this.backModel();
            this.$emit("deleteSuccess");
          })
          .catch((error) => this.commonHandleRequestError(error));
      });
    },
    selectHandler(event) {
      this.isOpenTransferDialog = false;
      this.selectedNodes = event.handlersData;
      this.form.flowNote = event.note;
    },

    getRelationTypeLabel(relationType) {
      let docRelationType = h.find(
        this.docRelationTypes,
        (docRelationType) => docRelationType.id === relationType
      );
      return docRelationType ? docRelationType.categoryName : null;
    },

    backModel() {
      const namePageBack = this.$route.path.split("/");
      this.$router.push({ name: `${namePageBack[3]}` });
    },

    tuChoiTiepNhanSuccess() {
      this.isOpenTuChoiDialog = false;
      this.message(
        "Thông báo",
        "Từ chối tiếp nhận văn bản thành công",
        "success",
        3000
      );
      this.backModel();
      this.$emit("rejectSuccess");
    },

    tuChoiTiepNhan() {
      this.isOpenTuChoiDialog = true;
    },

    clearValidate() {
      this.$refs.form.clearValidate("publisherId");
    },

    markAsRead() {
      if (this.incomingDoc && this.incomingDoc.forwardIncomingProcessId) {
        vbIncomingProcessService
          .markAsRead(this.incomingDoc.forwardIncomingProcessId)
          .then(() => null)
          .catch((error) => this.commonHandleRequestError(error));
      }
    },
    publisherDepartmentChange(event) {
      let department = event.selectedDepartment;
      this.form.publisherId = department ? department.id : null;
      this.isOpenSelectDepartmentDialog = false;
    },

    publisherIdChange() {
      this.$refs.form && this.$refs.form.validateField("publisherId");
      this.form.outsidePublisherName = "";
    },

    resetForm() {
      // this.uploadAttachment = null;
      // this.vbAttachment = null;
      this.incomingDoc = null;
      // this.flows = [];
      this.nextStepsCaNhan = null;
      this.id = null;
      this.deadlineDate = null;
      this.docDate = null;
      this.handler = [];
      this.priority = null;
      // this.incomingDate = null;
      // this.handlers = [];
      this.form = {
        docCode: null,
        // incomingDate: null,
        bookNumber: null,
        subBookNumber: null,
        docTypeName: null,
        attachmentFiles: [],
        quote: null,
        attachmentId: null,
        publisherId: null,
        docTypeId: null,
        docDate: null,
        deadlineDate: null,
        priorityId: null,
        numberOfCopy: null,
        numberOfPage: null,
        flowId: null,
        handlerId: null,
        handlerDeptId: null,
        handlerRoleId: null,
        flowNote: null,
        bookId: null,
      };

      let book = h.find(this.books, (item) => item.id == this.form.bookId);
      book && (book.bookCurrentNumber += 1);
    },

    cancel() {
      this.$emit("cancel");
    },

    flowIdChange() {
      this.$refs.form && this.$refs.form.validateField("flowId");
      this.handler = [];
      // this.loadNextStep();
      this.isOpenTransferDialog = true;
      this.selectedNodes = [];
    },

    generateNextBookNumber() {
      bookService.findById(this.form.bookId).then((response) => {
        this.form.bookNumber = response.data.bookCurrentNumber + 1;
      });
    },

    loadBooks() {
      return bookService
        .getAllBook(
          {
            bookType: constants.BOOK_TYPE.VB_DEN,
            includeIds: this.id ? [this.docInBook.bookId] : null,
            vbBookStatus: constants.VB_BOOK.STATUS.ACTIVE,
          },
          { sort: "bookName,asc", page: 0 }
        )
        .then((response) => (this.books = response.data));
    },

    removeUploadAttachment() {
      this.vbAttachment = null;
      this.form.attachmentId = null;
      this.form.attachmentFiles = [];
    },

    saveDoc() {
      this.$refs.form.validateField("bookId");
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
        } else {
          let submitForm = this.convertToSubmitForm();
          this.isProcessing = true;
          docInService
            .createIncomingDoc(submitForm)
            .then(() => {
              this.isProcessing = false;
              this.message(
                "Thông báo",
                "Lưu văn bản thành công",
                "success",
                4000
              );
              this.$emit("success");
            })
            .catch((error) => {
              this.isProcessing = false;
              return this.commonHandleRequestError(error);
            });
        }
      });
    },

    checkDocCodeDuplicated() {
      let docCode = this.form.docCode;
      docCode && (docCode = docCode.trim());
      if (!docCode) return Promise.resolve(true);
      return vbIncomingDocService
        .findAllByDocCodeAndToDeptId(docCode, this.id)
        .then((response) => {
          let vbIncomingDocs = response.data;
          if (!vbIncomingDocs || !vbIncomingDocs.length) return true;
          return this.$confirm(
            `Đã tồn tại văn bản với số ký hiệu [${docCode}]. Bạn vẫn muốn tiếp tục tiếp nhận văn bản này ?`,
            "Thông báo",
            {
              confirmButtonText: "Xác nhận",
              cancelButtonText: "Hủy bỏ",
              type: "warning",
            }
          ).then(() => true);
        });
    },

    forwardToNextHandler() {
      this.$refs.form.validateField("bookId");
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
        } else if (!this.flowId) {
          this.notify("Lỗi", "Chưa chọn luồng xử lý !", "error", 2000);
        } else if (this.selectedNodes.length == 0) {
          this.isOpenTransferDialog = true;
        } else {
          this.$refs.form.validateField("bookId");
          this.$refs.form.validate((valid) => {
            if (!valid) {
              this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
            } else {
              this.isProcessing = true;
              this.checkDocCodeDuplicated()
                .then((isContinue) => {
                  if (!isContinue) return;
                  let submitForm = this.convertToSubmitForm();
                  let processHandlerForms = this.selectedNodes
                    .filter(
                      (item) =>
                        item.stepType === constants.STEP.STEP_TYPE.CANHAN
                    )
                    .map((item) => {
                      let userDeptRole = item.userDeptRole;
                      return {
                        userId: userDeptRole.userId,
                        deptId: userDeptRole.deptId,
                        roleId: userDeptRole.roleId,
                        positionId: userDeptRole.positionId,
                        userDeptRoleId: userDeptRole.id,
                        processType: item.processType,
                        stepId: item.stepId,
                      };
                    });

                  let processHandlerDeptForms = this.selectedNodes
                    .filter(
                      (item) => item.stepType === constants.STEP.STEP_TYPE.DONVI
                    )
                    .map((item) => {
                      return {
                        deptId: item.department.id,
                        stepId: item.stepId,
                        processType: item.processType,
                      };
                    });

                  submitForm.flowId = this.form.flowId;
                  submitForm.note = this.form.flowNote;
                  submitForm.processHandlerForms = processHandlerForms;
                  submitForm.processHandlerDeptForms = processHandlerDeptForms;

                  docInService
                    .createIncomingDoc(submitForm)
                    .then(() => {
                      this.isProcessing = false;
                      this.message(
                        "Thông báo",
                        "Chuyển xử lý lãnh đạo thành công",
                        "success",
                        4000
                      );
                      this.$emit("cxlSuccess");
                    })
                    .catch((error) => {
                      this.isProcessing = false;
                      return this.commonHandleRequestError(error);
                    });
                })
                .catch(() => (this.isProcessing = false));
            }
          });
        }
      });
    },

    saveInBook() {
      this.$refs.form.validateField("bookId");
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.isOpenSaveDocInDialog = false;
          this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
        } else {
          this.$refs.form.validateField("bookId");
          this.$refs.form.validate((valid) => {
            if (!valid) {
              this.isOpenSaveDocInDialog = false;
              this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
            } else {
              this.isProcessing = true;
              this.checkDocCodeDuplicated()
                .then((isContinue) => {
                  if (!isContinue) {
                    this.isOpenSaveDocInDialog = false;
                    return;
                  }
                  let submitForm = this.convertToSubmitForm();
                  docInService
                    .saveIncomingDoc(submitForm)
                    .then(() => {
                      this.isProcessing = false;
                      this.message(
                        "Thông báo",
                        "Lưu trữ văn bản thành công",
                        "success",
                        4000
                      );
                      this.$emit("cxlSuccess");
                    })
                    .catch((error) => {
                      this.isProcessing = false;
                      this.isOpenSaveDocInDialog = false;
                      return this.commonHandleRequestError(error);
                    });
                })
                .catch(() => {
                  this.isProcessing = false;
                  this.isOpenSaveDocInDialog = false;
                });
            }
          });
        }
      });
    },

    loadDocDetail() {
      return docInService
        .findById(this.id)
        .then((response) => (this.incomingDoc = response.data));
    },

    loadDocInBook() {
      return docInBookService
        .findByDocId(this.id)
        .then((response) => (this.docInBook = response.data));
    },

    prepareFormForEditMode() {
      this.form.docCode = this.incomingDoc.docCode;
      this.form.docTypeId = this.incomingDoc.docTypeId;
      this.form.publisherId = this.incomingDoc.publisherId;
      this.form.priorityId = this.incomingDoc.priorityId;
      // this.form.securityId = this.incomingDoc.securityId;
      this.form.numberOfPage = this.incomingDoc.numberOfPage;
      this.form.numberOfCopy = this.incomingDoc.numberOfCopy;
      this.form.quote = this.incomingDoc.quote;
      this.form.quote = this.incomingDoc.quote;
      this.form.outsidePublisherName = this.incomingDoc.outsidePublisherName;
      this.form.status = this.incomingDoc.status;
      this.form.description = this.incomingDoc.description;
      this.form.isLawDocument =
        this.incomingDoc.isLawDocument === constants.TRUE;
      this.form.steeringTypeId = this.incomingDoc.steeringType;

      this.docDate = this.incomingDoc.docDate
        ? dateUtils.toMoment(this.incomingDoc.docDate).toDate()
        : null;
      this.deadlineDate = this.incomingDoc.deadlineDate
        ? dateUtils.toMoment(this.incomingDoc.deadlineDate).toDate()
        : this.deadlineDate;

      attachmentService
        .findAll({
          objectId: this.id,
          objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DEN,
        })
        .then((response) => {
          if (response.data && response.data.length) {
            this.vbAttachment = response.data[0];
            this.form.attachmentId = this.vbAttachment.id;
          }
        });

      if (this.docInBook) {
        this.form.bookId = this.docInBook.bookId;
        this.form.bookNumber = this.docInBook.bookNumber;
        this.form.subBookNumber = this.docInBook.subBookNumber;
      }

      //load vb liên quan
      docRelationService
        .findAll({
          objectId: this.id,
          objectType: constants.DOC_RELATION_OBJECT_TYPE.VB_DEN,
        })
        .then((response) => {
          this.docRelations = response.data;
        });

      /**
       * load thông tin priority;
       */
      this.incomingDoc.priorityId &&
        categoryViewService
          .findById(this.incomingDoc.priorityId)
          .then((response) => (this.priority = response.data));

      this.markAsRead();
    },

    convertToSubmitForm() {
      let docRelations = [];
      if (this.$refs && this.$refs.docRelationsForm) {
        docRelations.push(
          ...(this.$refs.docRelationsForm.getRelationDocs() || [])
        );
      }
      let submitForm = {
        id: this.id,
        docCode: this.form.docCode,
        docTypeId: this.form.docTypeId,
        docDate: this.form.docDate,
        publisherId: this.form.publisherId,
        outsidePublisherName: this.form.outsidePublisherName,
        priorityId: this.priority ? this.priority.id : null,
        // securityId: this.form.securityId,
        deadlineDate: this.form.deadlineDate,
        numberOfPage: this.form.numberOfPage,
        numberOfCopy: this.form.numberOfCopy,
        quote: this.form.quote,
        description: this.form.description,
        docRelations: this.id ? this.docRelations : docRelations,
        // incomingDate: this.form.incomingDate,

        docInBook: {
          bookId: this.form.bookId,
          bookNumber: this.form.bookNumber,
          subBookNumber: this.form.subBookNumber,
        },

        note: this.form.note,
        attachId: this.form.attachmentId,
        deptId: this.deptId,
        isLawDocument: this.form.isLawDocument
          ? constants.TRUE
          : constants.FALSE,
        steeringTypeId: this.form.steeringTypeId,
      };

      return submitForm;
    },

    receiverLabel(usersView) {
      return `${usersView.fullName} (${usersView.positionName} - ${usersView.deptName})`;
    },
    /**
     * filter lại danh sách đơn vị phát hành bên trong, chi cho phép ban hành trong đơn vị cha hoặc đơn vị ngang cấp
     * của đơn vị ban hành văn bản;
     */
    loadDepartments() {
      departmentService.findAll().then((response) => {
        let departments = h.findAll(
          response.data,
          (item) =>
            item.status === constants.DEPARTMENT.STATUS.ACTIVE ||
            item.id === this.form.publisherId
        );
        this.departments = departmentService
          .prepareReceiveDepartments(this.deptId, departments)
          .filter((x) => x.id !== "ROOT");
      });
    },

    uploadAttachmentSuccess(vbAttachment) {
      this.vbAttachment = vbAttachment;
      this.form.attachmentId = vbAttachment.id;
      this.form.numberOfPage = vbAttachment.pageNumber;
      this.form.numberOfCopy = 1;
    },

    loadNextStep() {
      this.handlers = [];
      nextStepInfoViewService.nextSteps(this.flowId, null).then((response) => {
        this.nextStepsCaNhan = h.findAll(
          response.data,
          (item) => item.stepType === constants.STEP.STEP_TYPE.CANHAN
        );
        this.nextStepsDonVi = h.findAll(
          response.data,
          (item) => item.stepType === constants.STEP.STEP_TYPE.DONVI
        );
        h.each(this.nextStepsCaNhan, (item) => this.loadUsersForNextStep(item));
        h.each(this.nextStepsDonVi, (item) => this.loadDeptForNextStep(item));
      });
    },

    loadUsersForNextStep(nextStep) {
      userDeptRoleViewService
        .findAllActiveForStepInfo(nextStep.vbStepInfoId)
        .then((response) => {
          this.handlers = this.handlers.concat(
            h.collect(response.data, (userView) => {
              return {
                id: userView.id,
                userView: userView,
                stepId: nextStep.id,
              };
            })
          );
        });
    },

    loadDeptForNextStep(nextStep) {
      if (!nextStep.deptId) return;

      departmentService.findById(nextStep.deptId).then((response) => {
        this.deptForNextStep = this.deptForNextStep.concat({
          id: response.data.id,
          deptName: response.data.deptName,
          stepId: nextStep.id,
        });
      });
    },

    receiverHandlerLabel(option) {
      let usersView = option.userView;

      return `${usersView.fullName} (${usersView.positionName} - ${usersView.deptName})`;
    },

    loadFlows() {
      flowService
        .findAll(
          { deptId: this.deptId, flowType: constants.FLOW_TYPE.VB_DEN },
          { sort: "flowName,asc" }
        )
        .then((response) => {
          this.flows = response.data;
          this.defaultFlow = this.flows.find(
            (flow) => flow.isDefault == constants.VB_FLOW.DEFAULT.IS_DEFAULT
          );
          if (this.defaultFlow) this.form.flowId = this.defaultFlow.id;
        });
    },

    loadCategories() {
      h.each(
        [
          constants.CATEGORY_GROUP_CODE.PRIORITY,
          constants.CATEGORY_GROUP_CODE.DOC_TYPE,
          constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE,
        ],

        (item) => {
          categoryViewService
            .findAll(
              { groupCode: item },
              { sort: "order,asc", page: 0, size: 1000 }
            )
            .then((response) => {
              switch (item) {
                case constants.CATEGORY_GROUP_CODE.PRIORITY:
                  // set default
                  this.priority = h.find(
                    response.data,
                    (priority) =>
                      priority.categoryCode == "BT" ||
                      priority.categoryName.toUpperCase() == "BÌNH THƯỜNG"
                  );
                  return (this.priorities = response.data.filter(
                    (item) => item.status !== "deactive"
                  ));

                case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                  return (this.docTypes = response.data.filter(
                    (item) => item.status !== "deactive"
                  ));

                case constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE:
                  return (this.docRelationTypes = response.data.filter(
                    (item) => item.status !== "deactive"
                  ));
              }
            });
        }
      );
    },

    escapeKeyListener: function (evt) {
      if (evt.keyCode === 27) {
        this.cancel();
      } else if (evt.keyCode === 118) {
        this.forwardToNextHandler(null);
      } else if (evt.keyCode === 119) {
        this.forwardToNextHandler({ flag: "isCopyNew" });
      } else if (evt.keyCode === 120) {
        this.forwardToNextHandler({ flag: "isCreateNew" });
      }
    },
    customDeptName(department) {
      return `${department.deptName} ${
        department.parentName ? ` (${department.parentName})` : ""
      }`;
    },
  },
};
</script>
<style scoped>
.field-needed:after {
  top: -15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/Create.vue